import {storeMaker} from '../utils/storeMaker.js'

export default {
    namespaced: true,
    state: storeMaker({
        // 这里写变量名
        // moduleName: '',
        eid:'',
        ename:'',
        uid: '',
        username: '',
        last_login:'',
        identity:'',
    }),
    mutations: {
        // 这里写变量更新方法，仿照写
        updateUId (state, uid) {
            state.uid = uid
        }, 
        updateUsername (state, username) {
            state.username = username
        }, 
        updateLastLogin(state, last_login) {
            state.last_login = last_login
        }, 
        updateIdentity(state, identity) {
            state.identity = identity
        }, 
        updateeId (state, eid) {
            state.eid = eid
        },
        updateeName (state, ename) {
            state.ename = ename
        },
    }
  }